import { jsx as i } from "react/jsx-runtime";
import { s, A as e } from "../../AmwayHighlightsItem-e8a3b1fa.mjs";
const d = ({ amwayHighlightsData: a }) => /* @__PURE__ */ i("div", { className: s["amway-highlights-container"], "data-testid": "amway-highlights-test-id", "data-pod-name": "commerce", children: a.map((t) => /* @__PURE__ */ i(
  e,
  {
    images: t.images,
    description: t.description,
    title: t.title
  },
  `${t.title}${t.description}`
)) });
export {
  d as default
};
//# sourceMappingURL=AmwayHighlights.js.map
